import React from 'react';

export const MenuIcon = ({ src, alt = '' }) => <img src={src} alt={alt} />;
